import { getDefaultPartner } from '~/features/admin/components/partner/utils'
import usePartnerConfigQueries from '~/features/partners/hooks/usePartnerConfigQueries'

/**
 * Runs the org/domain partner queries (fetch enabled).
 * Call once at the app root (RootConfigLayout); other code should use
 * usePartnerCentralized, which reads the same React Query cache without refetching.
 */
const useFetchPartnerConfig = () => {
  const { isLoading, partner } = usePartnerConfigQueries({ shouldFetch: true })

  return {
    isLoading,
    partner: getDefaultPartner(partner),
  }
}

export default useFetchPartnerConfig
